import Vue from 'vue'
import Router from 'vue-router'
import { authGuard } from "./auth/authGuard";
import store from './store'

Vue.use(Router)

const FAQ = () => import('./components/FAQ.vue')
const Account = () => import('./views/Account.vue')
const Support = () => import('./views/Support.vue')
const BraNFTs = () => import('./views/BraNFTs.vue')
const BraNFT = () => import('./views/BraNFT.vue')
const Gallery = () => import('./views/Gallery.vue')
const Commissions = () => import('./views/Commissions.vue')
const Wishlist = () => import('./views/Wishlist.vue')
const Wishlists = () => import('./views/Wishlists.vue')

let router = new Router({
    mode: 'history',
    routes: [
        {
            meta: {
                title: 'BraNFT™',
                metaTags: [
                    {
                        name: 'description',
                        content: 'BraNFT™',
                    },
                ],
            },
            path: '/BraNFT/:token_id?',
            name: 'branft',
            component: BraNFT,
        },
        {
            meta: {
                title: 'BraNFT™ Creators',
                metaTags: [
                    {
                        name: 'description',
                        content: 'Sign Up to Be a BraNFT™ Creator and Turn Your Old Bra Into Money!',
                    },
                ],
            },
            path: '/BraNFT',
            name: 'branfts',
            component: BraNFTs,
        },
        {
            meta: {
                title: 'BraNFT™ Creator Account',
                metaTags: [
                    {
                        name: 'description',
                        content: 'Your BraNFT™ Creator Account ',
                    },
                ],
            },
            path: '/account',
            name: 'account',
            component: Account,
            beforeEnter: authGuard
        },
        {
            meta: {
                title: 'BraNFT™ Support',
                metaTags: [
                    {
                        name: 'description',
                        content: 'Support Issues ',
                    },
                ],
            },
            path: '/support',
            name: 'support',
            component: Support
        },
        {
            meta: {
                title: 'FAQ (Frequently Asked Questions)',
                metaTags: [
                    {
                        name: 'description',
                        content: 'BraNFT™ Frequently Asked Questions',
                    },
                ],
            },
            path: '/faq',
            name: 'faq',
            component: FAQ,
        },
        {
            meta: {
                title: 'BraNFT™ Gallery',
                metaTags: [
                    {
                        name: 'description',
                        content: 'BraNFT™ Gallery',
                    },
                ],
            },
            path: '/gallery',
            name: 'gallery',
            component: Gallery,
        },
        {
            meta: {
                title: 'Commissioned BraNFT™ Creators',
                metaTags: [
                    {
                        name: 'description',
                        content: 'Commission Bids for BraNFT™ Creators',
                    },
                ],
            },
            path: '/commissions',
            name: 'commissions',
            component: Commissions,
        },
        {
            meta: {
                title: 'BraNFT™ Wish List',
                metaTags: [
                    {
                        name: 'description',
                        content: 'Group Funded Bra Wish Lists',
                    },
                ],
            },
            path: '/wishlist/:id',
            name: 'wishlist',
            component: Wishlist,
        },
        {
            meta: {
                title: 'BraNFT™ Wish Lists',
                metaTags: [
                    {
                        name: 'description',
                        content: 'Group Funded Bra Wish Lists',
                    },
                ],
            },
            path: '/wishlists',
            name: 'wishlists',
            component: Wishlists,
        },
        {
            meta: {
                title: 'BraNFT Home Page',
                metaTags: [
                    {
                        name: 'description',
                        content: `BraNFT™, Genesis of Tokenized Bras.`,
                    },
                ],
                skipIfAuthenticated: true,
            },
            path: '*',
            name: 'catchall',
            component: BraNFTs,
            beforeEnter(to, from, next) {
                if (to.query.bypass) {
                    next(to.query.bypass);
                } else {
                    next()
                }
            }
        },
    ],
})
router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
    // `/nested`'s will be chosen.
    const nearestWithTitle = to.matched
        .slice()
        .reverse()
        .find((r) => r.meta && r.meta.title)

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched
        .slice()
        .reverse()
        .find((r) => r.meta && r.meta.metaTags)

    const previousNearestWithMeta = from.matched
        .slice()
        .reverse()
        .find((r) => r.meta && r.meta.metaTags)

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title
    } else if (previousNearestWithMeta) {
        document.title = previousNearestWithMeta.meta.title
    }

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) => el.parentNode.removeChild(el))

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next()

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags
        .map((tagDef) => {
            const tag = document.createElement('meta')

            Object.keys(tagDef).forEach((key) => {
                tag.setAttribute(key, tagDef[key])
            })

            // We use this to track which meta tags we create so we don't interfere with other ones.
            tag.setAttribute('data-vue-router-controlled', '')

            return tag
        })
        // Add the meta tags to the document head.
        .forEach((tag) => document.head.appendChild(tag))

    next()
})
router.beforeEach((to, from, next) => {
    if (to.meta.skipIfAuthenticated && store.state.isAuthenticated) {
        next({
            path: '/account',
        });
    }
    next()
})

export default router
